<template>
    <ion-page class="ion-page" id="main">
        <default-header></default-header>

        <ion-content class="bg-image" fullscreen>
            <background slot="fixed"/>

            <flash-messages></flash-messages>
            <company-details></company-details>
            <company-settings v-if="canManageSettings"></company-settings>
        </ion-content>
    </ion-page>
</template>

<script>
    import CompanyDetails from "../../components/account/CompanyDetails";
    import DefaultHeader from "../../components/nav/DefaultHeader";
    import FlashMessages from "../../components/ui-elements/FlashMessages";
    import CompanySettings from "../../components/account/settings/CompanySettings";
    import Background from "../Background";

    export default {
        components: {Background, CompanySettings, FlashMessages, DefaultHeader, CompanyDetails},
        data() {
            return {
                canManageSettings: false,
            };
        },
        async mounted() {
            this.canManageSettings = await this.$store.dispatch('userHasPermission', 'manage company settings');
        }
    }
</script>
